import React from "react";
import { Button, Image } from "react-bootstrap";
import IconBox from "./IconBox";

const ActionButton = ({
  label,
  icon,
  variant = "primary",
  as,
  to,
  type,
  disabled,
  onClick,
  className = "",
  title,
  decorativeIcon = false,
}: {
  label: string;
  as?: any;
  to?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  onClick?: React.MouseEventHandler;
  className?: string;
  title?: string;
  /** Give the icon an empty alt so the button's accessible name is the label only. */
  decorativeIcon?: boolean;
} & (
  | { variant?: "primary" | "secondary"; icon?: string }
  | { variant: "icon"; icon: string }
)) => {
  return (
    <Button
      className={`btn-action ${
        variant === "icon" ? "btn-icon" : ""
      } ${className}`}
      as={as}
      to={to}
      type={type}
      disabled={disabled}
      onClick={onClick}
      title={title}
    >
      {variant === "icon" ? (
        <Image src={icon} alt={label} height={18} className="svg-light" />
      ) : (
        <span className="me-1">{label}</span>
      )}
      {!icon || variant === "icon" ? null : (
        <IconBox src={icon} alt={decorativeIcon ? "" : label} />
      )}
    </Button>
  );
};

export default ActionButton;
